import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Entity, Competition, CompetitionEntityScore } from '../../userApi';
import { State } from '../../redux/state';
import { LProps, withLocalization } from '../../utils/wrappers';
import ScoreboardTeams from '../../shared/ScoreboardTeams';
import { teamsLabelFor, isHiddenFromScoreboard } from '../../utils/competitionLabels';

interface ManualProps {
  entity: Entity;
}

interface Props extends ManualProps {
  competition: Competition;
  topSubEntityScores: CompetitionEntityScore[];
}

/**
 * Left-column ranking board:
 * - Department (university) page → Divisions in this department
 * - Division (team) page → omit campus-wide ranking (participants live in the Scoreboard column)
 */
const EntityRankingScoreboard = ({
  entity, competition, topSubEntityScores, t
}: LProps<Props>) => {
  const isDepartment = entity.type === Entity.TypeEnum.University;
  if (!isDepartment) {
    return null;
  }
  const title = `${teamsLabelFor(competition, t('Teams'))} ranking`;

  return (
    <div className="cc__white_box" style={{ marginTop: '1rem' }}>
      <h6 className="cc__darktext" style={{ marginBottom: '0.75rem' }}>{title}</h6>
      <div className="cc__scoreboard">
        <ScoreboardTeams
          teamScores={topSubEntityScores || []}
          compact={true}
          pointsOnly={true}
        />
      </div>
      {(!topSubEntityScores || topSubEntityScores.length === 0) &&
        <p className="cc__lighttext" style={{ marginTop: '0.5rem', marginBottom: 0 }}>
          {t('No divisions have points yet.')}
        </p>
      }
    </div>
  );
};

const mapStateToProps = (state: State, ownProps: ManualProps): Partial<Props> => {
  const competition = state.competition;
  const raw = (state.entityTopSubentityScores && state.entityTopSubentityScores[ownProps.entity.id]) || [];
  return {
    competition,
    topSubEntityScores: raw.filter((score) => {
      const entity = state.entities && state.entities[score.entityID];
      return entity && !isHiddenFromScoreboard(entity, competition);
    })
  };
};

export default compose(
  connect(mapStateToProps),
  withLocalization('entity')
)(EntityRankingScoreboard) as React.ComponentClass<ManualProps>;
